import React, { useEffect, useState } from "react";
import axios from "axios";
import MyLoader from "../Spinner/MyLoader";
import COLORS from "../resources/colors/COLORS";
import SessionManager from "../Utils/SessionManager";
import { Redirect } from "react-router-dom";
import "../css/Admin_css/admin-customize.css";
import myToast from "../Utils/MyToast";

const OldDueOtherAmount = () => {
  const [loggedIn, setLoggedIn] = useState(true);
  const [loading, setLoading] = useState(false);
  const [getClass, setGetClass] = useState([]);
  const [classBoard, setClassBoard] = useState([]);
  const [classMedium, setClassMedium] = useState([]);
  const [classSection, setClassSection] = useState([]);
  const [firstName, setFirstName] = useState(""); // Used for input value if needed

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setLoggedIn(false);
    }
  }, []);

  const regChange = (e) => {
    setFirstName(e.target.value);
  };

  if (!loggedIn) {
    return <Redirect to="/Login" />;
  }

  if (loading) {
    return <MyLoader />;
  }

  return (
    <div className="content">
      <div
        className="content-header"
        style={{ background: COLORS.primary_color_shade5 }}
      >
        <div className="leftside-content-header">
          <ul className="breadcrumbs">
            <li>
              <i className="fa fa-home" style={{ color: COLORS.white }} />
              <a href="#"> Old Due Collection </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="d-150">
        <section>
          <div
            className="row m-0"
            style={{
              padding: "3px 5px",
              background: "rgba(18,58,188,0.75)",
            }}
          >
            <div
              className="col-sm-6 col-md-6 text-center"
              style={{ padding: "5px" }}
            >
              <h3 className="text-white"> Other Amount </h3>
            </div>
            <div className="col-sm-6 col-md-6 viv">
              <p className="m-0">
                <input
                  type="text"
                  placeholder="Rs: 2500"
                  name="otherAmount"
                  style={{ width: "100%", padding: "10px", border: "none" }}
                />
              </p>
            </div>
          </div>
        </section>

        <section style={{ background: "#fff" }}>
          <div className="row m-0 p-2">
            {[1500, 500, 500].map((amount, index) => (
              <div className="col-md-4 mb-2" key={index}>
                <div
                  className="row m-0"
                  style={{
                    border: "2px solid rgba(18,58,188,0.75)",
                    borderRadius: "10px",
                  }}
                >
                  <div className="col-md-4 p-0">
                    <div className="due-main-ox">
                      <input
                        type="checkbox"
                        id={`DueAmount${index}`}
                        name="Due Amount"
                        value={firstName}
                        onChange={regChange}
                        className="checkbox-due-collecton"
                      />
                    </div>
                  </div>
                  <div className="col-md-8 col-form-label text-center">
                    <p className="m-0">
                      <strong>
                        Rs: <span>{amount}</span>
                      </strong>
                    </p>
                    <p className="m-0">2019</p>
                    <h6 className="m-0 text-success">Fee</h6>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div
            className="row"
            style={{ padding: "5px 0px", marginTop: "100px" }}
          >
            <div
              className="col-sm-6 col-md-6 text-center"
              style={{ padding: "5px", borderRight: "1px solid #8d8989" }}
            >
              <h3> Net Payable Amount </h3>
            </div>
            <div
              className="col-sm-6 col-md-6 viv"
              style={{ background: "none" }}
            >
              <p>
                <strong>
                  Rs: <span>2500</span>
                </strong>
              </p>
            </div>
          </div>

          <div className="row m-0">
            <div className="col-sm-12 col-md-12 btn btn-primary">
              <button
                className="btn btn-primary"
                style={{ width: "100%", fontSize: "24px", margin: "0px" }}
              >
                Collect Now
              </button>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default OldDueOtherAmount;
